import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const TotalPendingHeaderCell = ({ _customRowProps: { integration } }: HeaderCellProps) => {
  return (
    <Tooltip title="Total number of pending to be synced entities">
      <div>Total Pending</div>
    </Tooltip>
  );
};

export default TotalPendingHeaderCell;
